import { Component, OnInit } from '@angular/core';
import { SubscriptionRequest } from "../../models/SubscriptionRequest"
import { SubscriptionEvent } from "../../models/SubscriptionEvent"

import { FormGroup, FormControl } from '@angular/forms';
import { IsoeventsubscriptionmangementserviceService } from '../../services/isoeventsubscriptionmangementservice.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-unsubscribeevents',
  templateUrl: './unsubscribeevents.component.html',
  styleUrls: ['./unsubscribeevents.component.css']
})
export class UnsubscribeeventsComponent implements OnInit {

  userEmail: string = null;
  userUniqueName: string = null;

  isoEvents: SubscriptionEvent[] = [];

  model = new SubscriptionRequest();
  selectedEvents = null;
  submitted:boolean = false;
  requestProcessed:boolean = false;
  messageToDisplay:string = "";  
  requestFailed:boolean=false; 
  dataLoaded:boolean=false;

  constructor(private eventService: IsoeventsubscriptionmangementserviceService, private route: ActivatedRoute) { }

  async ngOnInit(): Promise<void> {
    this.route.queryParams
      .subscribe(params => { 
        this.userEmail = params.emailAddress;
        this.userUniqueName = params.uniqueName; 
      }
      );


   await this.eventService.getEventDetails().then(data => {
      this.isoEvents = data
    });

    this.eventService.getSubscriptionPerferences(this.userEmail,this.userUniqueName).subscribe(data => {
      this.model = data 

      if(!this.model){
        this.requestFailed=true;
        this.messageToDisplay="No matching subscription details found.";
        this.dataLoaded = true;
      }
      else{
        this.dataLoaded=true;       
        this.requestFailed= true;
        this.messageToDisplay="Unsubscribe request is not valid.";
      }

      console.log( this.model);
    });
  }


  async submit(subscriptionForm):Promise<void>{ 
    console.log('Form submitted',subscriptionForm);
    this.eventService.UnsubscribeToEvents(this.model);
    this.requestProcessed = true;
    this.messageToDisplay = "Request has been processed successfully";

  }


  ////Method to add the event name to the selected list
  onEventSelectionChange(e:any){ 
  
    if(!this.model.eventNames){
      this.model.eventNames=[];
    }

    if(e.currentTarget.checked){
      this.model.eventNames.push(e.currentTarget.value);
    }
    else{
      this.model.eventNames = this.model.eventNames.filter( eventName => eventName !=e.currentTarget.value)
    }
    this.selectedEvents=  this.model.eventNames.join();
  }


}
